export const ROW_HEIGHT = 42;
export const MAX_VISIBLE_ROWS_COUNT = 10;
